/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces" />
import { EndpointsEditorPanelContentType } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { ServiceEndpoint, ServiceEndpointType, ServiceEndpointAuthenticationScheme } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { InputValidation } from "ServiceEndpoints/Client/Contracts/FormInput_ServiceEndpoint";

export interface IEndpointsEditorPanelProps {
    onDismiss: () => void;
    onRefresh: () => void;
    onPrimaryAction: (serviceEndpoint?: ServiceEndpoint) => void;
    contentType: EndpointsEditorPanelContentType;
    panelTitle: string;
    endpoint?: ServiceEndpoint;
    panelDescription?: string;
    endpointType?: ServiceEndpointType;
    hideBackButton?: boolean;
    disableAllPipelinesSetting: boolean;
}

export interface GroupedEndpointType {
    name: string;
    displayName: string;
    endpointTypes: ServiceEndpointType[];
}

export interface IEndpointTypesPanelState {
    groupedEndpointTypes: GroupedEndpointType[];
    selectedEndpointType: GroupedEndpointType;
}

export interface IServiceEndpointAuthenticationSchemeExtended extends ServiceEndpointAuthenticationScheme {
    isRecommended: boolean;
    creationMode?: string;
    pageHeading: string;
    pageDescription: string;
    allowDraft: boolean;
}

export interface IEndpointAuthSchemeSelectionPanelState {
    selectedAuthSchemeIndex?: number;
}

export interface IEndpointsEditorPanelState {
    contentType: EndpointsEditorPanelContentType;
    previousContentType: EndpointsEditorPanelContentType;
    panelTitle: string;
    panelDescription?: string;
    endpointTypesPanelState?: IEndpointTypesPanelState;
    authSchemeSelectionPanelState?: IEndpointAuthSchemeSelectionPanelState;
}

export interface EndpointSaveStatus {
    verifyInProgress?: boolean;
    saveInProgress?: boolean;
    setupInProgress?: boolean;
    errorMessage?: string;
    activityId?: string;
}

export interface IEndpointsEditorPanelCallback {
    updateComponent: (panelState: IEndpointsEditorPanelState) => void;
}

export interface IEndpointEditorComponentProps {
    serviceEndpointType: ServiceEndpointType;
    draftEndpoint: ServiceEndpoint;
    isUpdateForm: boolean;
    allowAllPipelinesFlagState?: boolean;
    disableAllPipelinesSetting: boolean;
    updateDraftEndpointState: (endpoint: ServiceEndpoint) => void;
    updateInvalidInputsCount: (updateErrorsCountBy: number) => void;
    updateAllowAllPipelinesFlag?: (checked: boolean) => void;
    titleClassName?: string;
    disableDetailsHeader?: boolean;
    subscriptionSecondaryText?: () => JSX.Element;
    resourceGroupSecondaryText?: () => JSX.Element;
}

export interface InputDetails {
    inputId: string;
    initialValue: string | number | boolean;
    inputValidation: InputValidation;
    isConfidential: boolean;
    isUpdate: boolean;
}

export interface InputMetadata {
    inputId: string;
    value: string | number | boolean;
    errorMessage: string;
    isUpdate: boolean;
}